export const checks: any = {
    us: true,
    ca: true,
    jp: true,
    eu: false,
    uk: false,
    de: false,
    fr: false,
    it: false,
    es: false,
};
